import { createFileRoute } from "@tanstack/react-router";
import { UnassignedWorkPackagesPage } from "../../../../features/unassigned-work-packages/unassigned-work-packages-page";

export const Route = createFileRoute(
  "/_auth/_project/bid-row-details/$projectId/$subProjectId/unassigned-work-packages",
)({
  component: UnassignedWorkPackagesPage,
});
